var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#a6a6a6;} "), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,0.005v511.991h512v-18.07V0.005H0z M475.859,475.855H36.141V111.427h439.718V475.855z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.154,
    y: 309.893,
    className: "st0",
    width: 138.537,
    height: 118.967
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.308,
    y: 311.693,
    className: "st0",
    width: 162.625,
    height: 18.071
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.308,
    y: 408.99,
    className: "st0",
    width: 162.625,
    height: 18.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.308,
    y: 360.346,
    className: "st0",
    width: 162.625,
    height: 18.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.594,268.538h36.415c20.752,0,33.317-9.035,33.317-27.953c0-11.426-6.494-19.341-12.847-21.741v-0.283 c6.353-3.529,11.153-10.023,11.153-20.461c0-15.256-9.742-25.552-30.627-25.552H80.594c-0.838,0-1.403,0.565-1.403,1.411v93.159 C79.19,267.973,79.755,268.538,80.594,268.538z M99.944,190.185c0-0.556,0.264-0.846,0.847-0.846h14.682 c7.897,0,12.555,4.094,12.555,11.144c0,7.067-4.658,11.302-12.555,11.302h-14.682c-0.583,0-0.847-0.282-0.847-0.846V190.185z M99.944,228.576c0-0.556,0.264-0.838,0.847-0.838h15.794c8.489,0,12.997,4.658,12.997,12.009c0,7.473-4.508,12-12.997,12h-15.794 c-0.583,0-0.847-0.291-0.847-0.856V228.576z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M178.048,268.538h62.55c0.839,0,1.403-0.565,1.403-1.42v-15.662c0-0.857-0.564-1.412-1.403-1.412h-42.352 c-0.574,0-0.848-0.282-0.848-0.856v-75.229c0-0.846-0.556-1.411-1.411-1.411h-17.939c-0.846,0-1.402,0.565-1.402,1.411v93.159 C176.646,267.973,177.202,268.538,178.048,268.538z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M295.127,270.082c16.809,0,30.071-7.756,35.012-23.286c2.118-6.634,2.674-12,2.674-26.258 c0-14.259-0.556-19.624-2.674-26.259c-4.94-15.52-18.202-23.285-35.012-23.285c-16.799,0-30.07,7.765-35.002,23.285 c-2.126,6.635-2.691,12-2.691,26.259c0,14.258,0.565,19.624,2.691,26.258C265.057,262.327,278.328,270.082,295.127,270.082z M280.022,199.926c2.117-6.634,7.208-10.587,15.105-10.587c7.906,0,12.988,3.953,15.106,10.587 c1.129,3.397,1.553,8.039,1.553,20.612c0,12.555-0.424,17.223-1.553,20.603c-2.118,6.644-7.2,10.606-15.106,10.606 c-7.897,0-12.988-3.962-15.105-10.606c-1.121-3.38-1.553-8.048-1.553-20.603C278.469,207.965,278.901,203.323,280.022,199.926z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M395.424,270.082c16.932,0,30.203-8.603,35.012-24c1.685-5.214,2.383-13.12,2.383-21.59v-7.915 c0-0.83-0.565-1.403-1.403-1.403h-33.026c-0.857,0-1.421,0.574-1.421,1.403v13.571c0,0.838,0.564,1.402,1.421,1.402h12.979 c0.564,0,0.846,0.292,0.846,0.847c0,4.085-0.424,7.058-1.129,9.467c-1.976,6.345-8.188,9.883-15.388,9.883 c-8.33,0-13.562-3.962-15.68-10.606c-1.12-3.38-1.544-8.048-1.544-20.603c0-12.574,0.424-17.082,1.544-20.47 c2.118-6.636,7.209-10.729,15.406-10.729c7.897,0,12.688,3.388,16.509,9.882c0.282,0.706,0.988,0.988,1.985,0.706l15.097-6.352 c0.839-0.424,0.998-1.27,0.565-2.126c-4.526-11.577-16.235-20.453-34.156-20.453c-17.091,0-30.361,7.765-35.302,23.285 c-2.118,6.635-2.692,12-2.692,26.259c0,14.258,0.574,19.624,2.692,26.258C365.063,262.327,378.333,270.082,395.424,270.082z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/blog.7cc4db3bcc43791219f4193995f1ae68.svg";
export { ForwardRef as ReactComponent };